export default __webpack_public_path__ + "maps-examples-image-source-thumbnail-480-bdeaf78e7d2a486865e9bd230ca4db50.webp";